export const LEGAL_NOTICE_FONT_SIZE = 14;
export const LEGAL_NOTICE_LINE_HEIGHT = "1.8em";
